<template>
  <div>
    <div class="banner">
      <h4>{{ title }}</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">
     <v-row dense>
        <v-col class="d-flex" cols="12" sm="12">
            <v-select 
            :items="types_reasons"
            item-text="description"
            item-value="description"
            class="rounded-lg" 
            color="#41916b"
            outlined  
            v-model="type_reason" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Tipo da Não Captação<span style="color: red;">*</span>
                </template>
            </v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12" v-if="isNotCapturedByOrgan">
            <v-select 
            :items="orgons_type"
            item-text="description"
            item-value="id"
            class="rounded-lg" 
            color="#41916b"
            outlined 
            v-model="reasonsForm.type_orgon_id" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Tipo de Orgão/Tecido<span style="color: red;">*</span>
                </template>
            </v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12" v-if="isCapturedByCirurgy">
            <v-select 
            :items="types_captations"
            item-text="description"
            item-value="id"
            class="rounded-lg" 
            color="#41916b"
            outlined 
            v-model="reasonsForm.type_captation_id" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Tipo da Captação<span style="color: red;">*</span>
                </template>
            </v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
            <v-text-field 
            class="rounded-lg" 
            color="#41916b"
            outlined  
            v-model="reasonsForm.description" 
            :rules="formRules" 
            dense>
                <template v-slot:label>
                    Nome do Motivo da Não Captação <span style="color: red;">*</span>
                </template>
            </v-text-field>
        </v-col>
     </v-row> 
     <v-card-actions class="d-flex justify-end">
        <v-btn class="rounded-lg" color="#e74c3c" text elevation="0" @click="closeDialog()">
            <span>{{$t('buttons.cancel')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" color="blue" text elevation="0" @click="$refs.form.reset()">
            <span>{{$t('buttons.clean_up')}}</span>
        </v-btn>

        <v-btn class="rounded-lg" elevation="0" color="#41916b" type="submit" :loading="loading">
            <span class="textBtn">{{ btnMessage }}</span>
            <v-icon color="#FFFFFF" small class="ml-2">mdi-arrow-right</v-icon>
        </v-btn>
    </v-card-actions>
    </v-form> 
  </div>
</template>
<script>
import { getTypeReasonNotCaptureds, getTypeCaptations, saveReasonNotCaptation } from "@/service/basic-registrations/ReasonNotCaptationService";
import { getTypeOrgons } from "@/service/basic-registrations/OrgonsTissuesService";
import {  mapActions } from "vuex";
import Formatters from '@/utils/Formatters';
export default {
  data() {
    return {
        dialog: false,
        formRules: [(v) => !!v || "Campo obrigatório."],
        loading: false,
        type_reason: '',
        types_reasons: [],
        orgons_type: [],
        reasonsForm: {},
        types_captations: [],
      };
  },

  props: {
      resource: {
        type: Object,
      }
    },

  computed: {
    isNotCapturedByOrgan() {
      return this.type_reason == 'Não captação por Órgão';
    },
    isCapturedByCirurgy() {
      return this.type_reason == 'Não efetivação da captação';
    },

    title() {
      return this.reasonsForm.id ? 'Atualizar Motivo de Não Captação' : 'Novo Motivo de Não Captação';
    },

    btnMessage() {
      return this.reasonsForm.id ? 'Atualizar' : 'Salvar';
    }
  },

  watch: {
    'resource': {
      handler(item) {
        if (!item) return;

        this.reasonsForm = { ...item };
        this.type_reason = this.reasonsForm.type_reason_not_captured.description
        this.reasonsForm.type_orgon_id = parseInt(this.reasonsForm.type_orgon_id)

        if (!item.id && this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },

      immediate: true
    }
  },

  async mounted() {
    try {
      const [types_reasons, types_captations, orgons_type] = await Promise.all([
        getTypeReasonNotCaptureds(),
        getTypeCaptations(),
        getTypeOrgons()
      ]);

      this.types_reasons = types_reasons;
      this.types_captations = types_captations;
      this.orgons_type = orgons_type;

    }catch(error) {
      this.changeSnackBarData({
        status: true,
        type: 'erro', 
        titleMessage: this.$t('messages.something_went_wrong'),
        bodyMessage: Formatters.formatErrorMessage(error),
        cardColor: 'red',
        titleIcon: 'mdi-close-circle',
      });

      setTimeout(() => {
        this.closeSnackBar(); 
      }, 3000);
    }
  },

  methods: {
    ...mapActions([
      "changeSnackBarData"
    ]),
 
    create() {
      this.loading = true;
      if (this.$refs.form.validate()) {
 
        const dados = {
            description: this.reasonsForm.description,
            type_reason_not_captured_id: this.types_reasons.filter(item => item.description == this.type_reason)[0].id,
            type_orgon_id: this.reasonsForm.type_orgon_id,
            type_captation_id: this.reasonsForm.type_captation_id ?? null
        }
 
            saveReasonNotCaptation(this.reasonsForm.id || null, dados).then((response) => {
            this.loading = false; 
             
            this.changeSnackBarData({
              status: true,
              type: 'success', 
              titleMessage: response.data.message,
              bodyMessage: '',
              cardColor: 'success',
              titleIcon: 'mdi-check-circle',
            }); 

            setTimeout(() => { 
               this.closeSnackBar();
               this.closeDialog();
            }, 3000);
 
          }).catch((err) => {
            this.loading = false;
             this.changeSnackBarData({
                status: true,
                type: 'erro', 
                titleMessage: this.$t('messages.something_went_wrong'),
                bodyMessage: Formatters.formatErrorMessage(err),
                cardColor: 'red',
                titleIcon: 'mdi-close-circle',
            });

            setTimeout(() => {
              this.closeSnackBar(); 
            }, 3000);
          });   
      }
    },

    closeDialog() {
        this.reasonsForm = {
            id: null,
            description: null,
            type_reason_not_captured_id: null,
            type_orgon_id: null,
        }; 
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
        this.$emit("closeDialog"); 
    },

    closeSnackBar(){
        this.changeSnackBarData({
            status: false,
            type: '', 
            titleMessage: '',
            bodyMessage: '',
            cardColor: '',
            titleIcon: '',
        });
    } 
  }, 
};
</script>
<style scoped>
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.card {
  padding: 35px;
}

.banner {
  background: #b3ffab; 
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c); 
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd); 

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}
</style>
  